const getDestination = function () {
  let url = window.location.href.split('?')
  if (url.length === 2) {
    url = url[1].split('=')
    if (url.length === 2) {
      if (url[0] === 'destination') return url[1]
      else return 'bigsky'
    } else {
      return 'bigsky'
    }
  } else {
    return 'bigsky'
  }
}

const getUrl = function () {
  const dest = getDestination()
  if (dest.match(/^copper.*$/)) { // tech4snow console
    return 'https://s3.us-east-2.amazonaws.com/tech4snow/feeds/1/'
  } else { // spotlio system
    return 'https://spotlio-snowconditions.s3.amazonaws.com/' + dest + '/'
  }
}

const configService = {
  baseUrl: getUrl(),
  uris: {
    status: 'status.json',
    conditions: 'conditions.json'
  }
}

export default configService



// WEBPACK FOOTER //
// ./src/services/config.js